var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09117 16.9999C6.8945 16.9999 7.54572 16.3487 7.54572 15.5454C7.54572 14.742 6.8945 14.0908 6.09117 14.0908C5.28785 14.0908 4.63663 14.742 4.63663 15.5454C4.63663 16.3487 5.28785 16.9999 6.09117 16.9999Z",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8187 16.9999C15.622 16.9999 16.2733 16.3487 16.2733 15.5454C16.2733 14.742 15.622 14.0908 14.8187 14.0908C14.0154 14.0908 13.3642 14.742 13.3642 15.5454C13.3642 16.3487 14.0154 16.9999 14.8187 16.9999Z",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39676 4.63636H17.0004L15.7786 10.7382C15.6413 11.4293 15.0285 11.9226 14.324 11.9091H6.63676C5.90184 11.9153 5.27773 11.3724 5.18222 10.6436L4.07676 2.26545C3.98194 1.54225 3.36615 1.0011 2.63676 1H1.0004",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.f3847d9f.svg";
export { ForwardRef as ReactComponent };